import {
  EKybStatus,
  IBrokerKybInfo,
} from "@rentiohq/shared-frontend/dist/types/payment.types";

// DEV-2801: the hosted KYB session statuses in which the company submitted and Mangopay (or the owners) decide
export const KYB_SUBMITTED_STATUSES = [EKybStatus.Review, EKybStatus.Validated];

// An owner's (PSC) own verification: done when validated or abandoned, over without a pass when refused
const KYB_OWNER_DONE_STATUSES = [EKybStatus.Validated, EKybStatus.Abandoned];
const KYB_OWNER_REFUSED_STATUSES = [EKybStatus.Rejected, EKybStatus.Refused];

export const isKybSubmitted = (kybInfo?: IBrokerKybInfo | null) =>
  !!kybInfo?.kybStatus && KYB_SUBMITTED_STATUSES.includes(kybInfo.kybStatus);

// The owners Mangopay refused, and those that still have to verify themselves
export const getKybOwnerGroups = (
  owners: IBrokerKybInfo["kybOwners"] = [],
) => ({
  refused: owners.filter(owner =>
    KYB_OWNER_REFUSED_STATUSES.includes(owner.status),
  ),
  pending: owners.filter(
    owner =>
      !KYB_OWNER_DONE_STATUSES.includes(owner.status) &&
      !KYB_OWNER_REFUSED_STATUSES.includes(owner.status),
  ),
});

// Mangopay takes a few seconds to process a submitted session, so right after the return from its page the session
// can still read PENDING: read it again for a short while before showing "not finished"
const KYB_RETURN_RETRY_DELAY_MS = 3000;
const KYB_RETURN_MAX_READS = 5;

export const fetchKybInfoAfterReturn = async (
  fetchKybInfo: () => Promise<IBrokerKybInfo | null | undefined>,
) => {
  let kybInfo = await fetchKybInfo();

  for (
    let read = 1;
    read < KYB_RETURN_MAX_READS && kybInfo?.kybStatus === EKybStatus.Pending;
    read += 1
  ) {
    await new Promise(resolve =>
      setTimeout(resolve, KYB_RETURN_RETRY_DELAY_MS),
    );
    kybInfo = await fetchKybInfo();
  }

  return kybInfo;
};
